<script>
  export default {
    props: ['userId', 'active'],
    created() {
      this.state = this.active
    },
    data() {
      return {
        state: null
      }
    },
    methods: {
      switched() {
        this.$http.post('/api/v1/app/admin/settings/pays', { id: this.userId, pay: {allow_sms_signature_pad: this.state}}).then(response => {
          this.notifySuccess('SMS setting successfully updated')
        }, response => {
          this.notifyError('Something went wrong. Pay settins not updated')
          this.state = !this.state
        })
      }
    }
  }
</script>

<template>
  <div>
    <!-- Switch -->
    <div class="switch">
      <label>
        Off
        <input type="checkbox" @change='switched' v-model='state'>
        <span class="lever"></span>
        On
      </label>
    </div>
  </div>
</template>

